import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import jwtValidate from '../../data/services/jwt'
import persistentStore from '../../data/persistentStore'
const ProtectedRoute = () => {
  const params = useParams()
  const location = useLocation()

  const searchInfo = jwtValidate(window.atob(params?.jwt))
  persistentStore.setPubToken(params?.jwt)
  persistentStore.setSearch(searchInfo)
  if (!searchInfo) {
    return (
      <Navigate
        to="/expired"
        state={{ ...location.state, from: location }}
        replace
      />
    )
  }

  return <Outlet />
}

export default ProtectedRoute
